import script from "./OArvoreDeSelecoes.vue?vue&type=script&lang=ts&setup=true"
export * from "./OArvoreDeSelecoes.vue?vue&type=script&lang=ts&setup=true"

import "./OArvoreDeSelecoes.vue?vue&type=style&index=0&id=705330d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705330d8"]])

export default __exports__